// window.addEventListener("load", function () {
//   document.querySelectorAll("[data-truncate]").forEach(function (element) {
//     element.addEventListener("click", function (event) {
//       if (!event.target.matches("a, a *")) {
//         event.preventDefault();

//         var shortElement = document.querySelector(".truncate__short");
//         var longElement = document.querySelector(".truncate__long");

//         if (shortElement.classList.contains("active")) {
//           shortElement.classList.remove("active");
//           longElement.classList.add("active");
//         } else {
//           shortElement.classList.add("active");
//           longElement.classList.remove("active");
//         }
//       }
//     });
//   });
// });


$(function() {
  var Accordion = function(el, multiple) {
  this.el = el || {};
  this.multiple = multiple || false;

    var links = this.el.find('.product-title');
    links.on('click', {
      el: this.el,
      multiple: this.multiple
    }, this.dropdown)
  }

  Accordion.prototype.dropdown = function(e) {
    var $el = e.data.el;
    $this = $(this),
    $next = $this.next();
  
    $next.slideToggle();
    $this.parent().toggleClass('open');
  
    if (!e.data.multiple) {
      $el.find('.product-detail-content').not($next).slideUp().parent().removeClass('open');
    };
  }
  var accordion = new Accordion($('.product-detail-accordion-main'), false);
});

$('.slider-gallery-main').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  arroes: true,
  dots: false,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 3
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 1
      }
    }
  ]
});

jQuery(document).ready(function(jQuery){
  
  jQuery(".product-thumbnail .product-thumbnail__title").each(function () {
    function e() {
      jQuery(".product-thumbnail .product-thumbnail__title").css("height", "auto");
      var e = -1;
      jQuery(".product-thumbnail .product-thumbnail__title").each(function () {
        var t = jQuery(this).outerHeight();
        e = t > e ? t : e
      }), jQuery(".product-thumbnail .product-thumbnail__title").css("height", e)
    }
    jQuery(this), jQuery(window).on("load resize orientationchange", e)
  });

 $(".readmore_btn").click(function(){
    $(this).toggleClass("active-btn");
    $(".product_description_part_small").toggleClass("active");    
});

});

document.addEventListener("DOMContentLoaded", function() {
  const ticker = document.querySelector('.horizontal-ticker');
  if (!ticker) return;

  const startDateStr = ticker.getAttribute('data-startdate');
  const endDateStr = ticker.getAttribute('data-enddate');
  if (!startDateStr || !endDateStr) return;

  const startDate = new Date(startDateStr);
  const endDate = new Date(endDateStr);
  const currentDate = new Date();
  const blackFridayBanner = document.querySelector('.black-friday__banner');
  const skincareBanner = document.querySelector('.skinacare__banner');

  if (!blackFridayBanner || !skincareBanner) return;

  if (currentDate >= startDate && currentDate <= endDate) {
    blackFridayBanner.classList.remove('hide');
    skincareBanner.classList.add('hide');
  } else {
    blackFridayBanner.classList.add('hide');
    skincareBanner.classList.remove('hide');
  }
});

/* Totality mobile sticky Add to Cart â€” 2026-08-12 */
(function () {
  'use strict';

  var MOBILE_MAX_WIDTH = 798;
  var SHOW_AFTER_SCROLL = 420;
  var UPNEEQ_MONTHLY_HANDLE = 'upneeq-30-vials';
  var UPNEEQ_ONE_TIME_HANDLES = [
    'upneeq-sample-box-3-vials',
    'upneeq-sample-box-10-vials-1',
    'upneeq-eyedrops-45-vials'
  ];

  function getProductHandle() {
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  function configureUpneeqSubscriptions() {
    var handle = getProductHandle();
    var isMonthlyProduct = handle === UPNEEQ_MONTHLY_HANDLE;
    var isOneTimeProduct = UPNEEQ_ONE_TIME_HANDLES.indexOf(handle) !== -1;
    if (!isMonthlyProduct && !isOneTimeProduct) return true;

    var wrapper = document.querySelector('.bsub-widget__wrapper');
    if (!wrapper) return false;

    var groupInputs = wrapper.querySelectorAll('input[name="bsub-selling-plan-group"]');
    var onceInput = wrapper.querySelector('input[name="bsub-selling-plan-group"][value="once"]');
    var subscriptionInput = wrapper.querySelector('input[name="bsub-selling-plan-group"]:not([value="once"])');
    var plans = wrapper.querySelectorAll('.bsub-widget__plan[data-bsub-selling-plan-id]');
    var plansContainer = wrapper.querySelector('.bsub-widget__plans-container');

    if (!groupInputs.length || !onceInput || !subscriptionInput) return false;

    if (isOneTimeProduct) {
      if (!onceInput.checked) onceInput.click();

      subscriptionInput.closest('.bsub-widget__group').classList.add('totality-bsub-hidden');
      if (plansContainer) plansContainer.classList.add('totality-bsub-hidden');

      var note = wrapper.querySelector('.totality-upneeq-subscription-note');
      if (!note) {
        note = document.createElement('p');
        note.className = 'totality-upneeq-subscription-note';
        wrapper.appendChild(note);
      }
      note.innerHTML = handle === 'upneeq-eyedrops-45-vials'
        ? 'This value pack is available as a one-time purchase. For monthly delivery, choose the <a href="/products/upneeq-30-vials">30 Day Supply</a>.'
        : 'For ongoing monthly delivery, choose the <a href="/products/upneeq-30-vials">30 Day Supply</a>.';
      return true;
    }

    subscriptionInput.closest('.bsub-widget__group').classList.remove('totality-bsub-hidden');
    if (plansContainer) plansContainer.classList.remove('totality-bsub-hidden');

    var monthlyPlan = null;
    for (var i = 0; i < plans.length; i += 1) {
      var isMonthlyPlan = plans[i].getAttribute('data-bsub-selling-plan-id') === '2082373763';
      plans[i].classList.toggle('totality-bsub-hidden', !isMonthlyPlan);
      if (isMonthlyPlan) monthlyPlan = plans[i];
    }

    if (subscriptionInput.checked && monthlyPlan) {
      var monthlyPlanInput = monthlyPlan.querySelector('input[data-bsub-selling-plan-input]');
      if (monthlyPlanInput && !monthlyPlanInput.checked) monthlyPlanInput.click();
    }

    var existingNote = wrapper.querySelector('.totality-upneeq-subscription-note');
    if (existingNote) existingNote.remove();
    return true;
  }

  function initUpneeqSubscriptionClarity() {
    var attempts = 0;
    function retry() {
      configureUpneeqSubscriptions();
      attempts += 1;
      if (attempts < 24) window.setTimeout(retry, 250);
    }
    retry();
  }

  function initMobileStickyAddToCart() {
    if (document.getElementById('totality-mobile-sticky-atc')) return;

    var productForm = document.querySelector('.product_form[data-product-form] form[action*="/cart/add"]');
    if (!productForm) return;

    var mainButton = productForm.querySelector('[data-add-to-cart-trigger]');
    if (!mainButton) return;

    var productArea = productForm.closest('.product__information') || document;
    var titleNode = productArea.querySelector('h1') || document.querySelector('h1');

    var bar = document.createElement('aside');
    bar.id = 'totality-mobile-sticky-atc';
    bar.setAttribute('aria-label', 'Quick add to cart');
    bar.innerHTML =
      '<div class="totality-sticky-atc__details">' +
        '<span class="totality-sticky-atc__title"></span>' +
        '<span class="totality-sticky-atc__price"></span>' +
      '</div>' +
      '<button class="totality-sticky-atc__button" type="button">Add to cart</button>';
    document.body.appendChild(bar);

    var stickyTitle = bar.querySelector('.totality-sticky-atc__title');
    var stickyPrice = bar.querySelector('.totality-sticky-atc__price');
    var stickyButton = bar.querySelector('.totality-sticky-atc__button');
    var mainButtonInView = false;
    var clickCooldown = false;

    function isVisible(element) {
      if (!element) return false;
      var style = window.getComputedStyle(element);
      var rect = element.getBoundingClientRect();
      return style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        Number(style.opacity || 1) > 0.05 &&
        rect.width > 0 && rect.height > 0;
    }

    function cartDrawerIsOpen() {
      var overlays = document.querySelectorAll('.ajax-cart__overlay');
      for (var i = 0; i < overlays.length; i += 1) {
        if (isVisible(overlays[i])) return true;
      }
      return false;
    }

    function updateContent() {
      stickyTitle.textContent = titleNode ? titleNode.textContent.trim() : 'Ready to order?';
      var priceNode = productArea.querySelector('.current_price, .price .money, .product__price .money, .money');
      var selectedGroup = productForm.querySelector('input[name="bsub-selling-plan-group"]:checked');
      var selectedPlan = productForm.querySelector('input[data-bsub-selling-plan-input]:checked');
      var selectedPlanPrice = selectedPlan && selectedPlan.closest('.bsub-widget__plan')
        ? selectedPlan.closest('.bsub-widget__plan').querySelector('[data-bsub-per-delivery-price]')
        : null;
      var isSubscription = selectedGroup && selectedGroup.value !== 'once' && selectedPlanPrice;
      stickyPrice.textContent = isSubscription
        ? selectedPlanPrice.textContent.trim() + ' / delivery'
        : (priceNode ? priceNode.textContent.trim() : '');
      stickyButton.disabled = mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true' || clickCooldown;

      var sourceLabel = mainButton.getAttribute('data-label') || mainButton.textContent || 'Add to cart';
      stickyButton.textContent = sourceLabel.trim();
    }

    function updateVisibility() {
      var isMobile = window.innerWidth <= MOBILE_MAX_WIDTH;
      var shouldShow = window.innerWidth <= MOBILE_MAX_WIDTH &&
        window.scrollY >= SHOW_AFTER_SCROLL &&
        !mainButtonInView &&
        !cartDrawerIsOpen();
      bar.classList.toggle('is-visible', shouldShow);
      bar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      bar.style.setProperty('display', isMobile ? 'flex' : 'none', 'important');
      bar.style.setProperty('opacity', shouldShow ? '1' : '0', 'important');
      bar.style.setProperty('pointer-events', shouldShow ? 'auto' : 'none', 'important');
      bar.style.setProperty('transform', shouldShow ? 'translateY(0)' : 'translateY(110%)', 'important');
      updateContent();
    }

    stickyButton.addEventListener('click', function () {
      if (stickyButton.disabled || !isVisible(mainButton)) return;
      clickCooldown = true;
      bar.classList.remove('is-visible');
      updateContent();
      mainButton.click();
      window.setTimeout(function () {
        clickCooldown = false;
        updateVisibility();
      }, 1400);
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        mainButtonInView = entries[0].isIntersecting;
        updateVisibility();
      }, { threshold: 0.15 });
      observer.observe(mainButton);
    }

    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility);
    productForm.addEventListener('change', function () {
      window.setTimeout(function () {
        configureUpneeqSubscriptions();
        updateContent();
      }, 120);
    });
    document.addEventListener('ajaxCart:updated', updateVisibility);

    updateContent();
    updateVisibility();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initUpneeqSubscriptionClarity();
      initMobileStickyAddToCart();
    });
  } else {
    initUpneeqSubscriptionClarity();
    initMobileStickyAddToCart();
  }
}());




/* Totality purchase-flow overlay controls â€” 2026-08-12 */
(function () {
  'use strict';

  var PROMOTION_DELAY_MS = 35000;
  var startedAt = Date.now();
  var delayTimer = null;
  var watchedAnswerAiFrames = new WeakSet();
  var answerAiObservers = [];

  function isCartOrCheckout() {
    return /^\/(cart|checkouts?)(\/|$)/.test(window.location.pathname);
  }

  function isRxProduct() {
    return Boolean(document.querySelector(
      'form[action*="/cart/add"] input[name="properties[_approval_needed]"]'
    ));
  }

  function promotionGateIsActive() {
    return isCartOrCheckout() || isRxProduct() || Date.now() - startedAt < PROMOTION_DELAY_MS;
  }

  function findPopupRoot(closeButton) {
    var node = closeButton;
    var fixedAncestor = null;

    while (node && node !== document.body) {
      if (window.getComputedStyle(node).position === 'fixed') fixedAncestor = node;
      node = node.parentElement;
    }

    return fixedAncestor || closeButton.closest('[role="dialog"]') || closeButton.parentElement;
  }

  function updateKlaviyoPopups() {
    var gateIsActive = promotionGateIsActive();
    var closeButtons = document.querySelectorAll('button.klaviyo-close-form');

    for (var i = 0; i < closeButtons.length; i += 1) {
      var popupRoot = findPopupRoot(closeButtons[i]);
      if (popupRoot) popupRoot.classList.toggle('totality-klaviyo-popup-gated', gateIsActive);
    }

    if (isRxProduct() || isCartOrCheckout()) {
      document.body.classList.add('totality-promotions-suppressed');
      document.body.classList.remove('totality-promotions-delayed');
    } else if (gateIsActive) {
      document.body.classList.add('totality-promotions-delayed');
      document.body.classList.remove('totality-promotions-suppressed');
    } else {
      document.body.classList.remove('totality-promotions-delayed');
      document.body.classList.remove('totality-promotions-suppressed');
    }
  }

  function keepAnswerAiCompact() {
    if (!document.body.classList.contains('product')) return;

    var notifications = document.querySelectorAll(
      'iframe[id^="notifications_"][src*="answerai.co.uk"]'
    );
    for (var i = 0; i < notifications.length; i += 1) {
      var frame = notifications[i];
      if (frame.style.getPropertyValue('display') !== 'none') {
        frame.style.setProperty('display', 'none', 'important');
      }

      if (!watchedAnswerAiFrames.has(frame)) {
        watchedAnswerAiFrames.add(frame);
        var frameObserver = new MutationObserver(keepAnswerAiCompact);
        frameObserver.observe(frame, { attributes: true, attributeFilter: ['style'] });
        answerAiObservers.push(frameObserver);
      }
    }
  }

  function updatePurchaseFlowControls() {
    updateKlaviyoPopups();
    keepAnswerAiCompact();
  }

  function initPurchaseFlowControls() {
    updatePurchaseFlowControls();

    var observer = new MutationObserver(updatePurchaseFlowControls);
    observer.observe(document.body, { childList: true, subtree: true });

    delayTimer = window.setTimeout(updatePurchaseFlowControls, PROMOTION_DELAY_MS + 100);
    window.addEventListener('pagehide', function () {
      observer.disconnect();
      for (var i = 0; i < answerAiObservers.length; i += 1) {
        answerAiObservers[i].disconnect();
      }
      if (delayTimer) window.clearTimeout(delayTimer);
    }, { once: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPurchaseFlowControls);
  } else {
    initPurchaseFlowControls();
  }
}());
